import React, { FC } from 'react'
import ScrollableAnchor from 'react-scrollable-anchor'
import styled from 'styled-components'

interface AnchorPointProps {
  anchor?: string;
}

export const AnchorPoint: FC<AnchorPointProps> = ({ anchor }) => {
  if (!anchor) return null

  return (
    <ScrollableAnchor id={anchor}>
      <AnchorElement />
    </ScrollableAnchor>
  )
}

const AnchorElement = styled.div`
  position: absolute;
  top: 0;
`
